(() => {
  angular
    .module('gm.common.ui')
    .directive('gmyOutClick', gmyOutClick);

  function gmyOutClick(
    $timeout,
    $parse,
    $document
  ) {
    'ngInject';

    return {
      restrict: 'A',
      link(scope, element, attrs) {
        const outClickCb = $parse(attrs.gmyOutClick);
        let isProcessClick = true;
        let clickInsideTimeout = null;

        function callCb() {
          outClickCb(scope);
        }

        function onClickInside() {
          isProcessClick = false;

          if (clickInsideTimeout) {
            $timeout.cancel(clickInsideTimeout);
          }

          clickInsideTimeout = $timeout(() => { isProcessClick = true; }, 10);
        }

        function onClickOutside() {
          if (isProcessClick) {
            callCb();
          }
        }

        function onDestroy() {
          element.off('click focusin', onClickInside);
          $document.off('click focusin', onClickOutside);
        }

        element.on('click focusin', onClickInside);
        $document.on('click focusin', onClickOutside);
        scope.$on('$destroy', onDestroy);
      }
    };
  }
})();
